const endOfDay = (ending) => {
  if ([11, 12, 13].includes(ending % 100)) {
    return 'th';
  }

  switch (ending.at(-1)) {
    case '1':
      return 'st';
    case '2':
      return 'nd';
    case '3':
      return 'rd';
    default:
      return 'th';
  }
};

export const getOrdinalNumber = (number) => {
  const numberToString = number.toString();

  return `${numberToString}${endOfDay(numberToString)}`;
};
